<div *ngIf="params && params.showCheckbox" class="checkbox-container">
	<mat-icon *ngIf="allSelected === 'checked'" svgIcon="checkbox_checked" class="copo-datacenter-grid-icon-16"
		(click)="unselect($event)"></mat-icon>
	<mat-icon *ngIf="allSelected === 'unchecked'" svgIcon="checkbox" class="copo-datacenter-grid-icon-16"
		(click)="select($event)"></mat-icon>
	<mat-icon *ngIf="allSelected === 'indeterminate'" svgIcon="checkbox_indeterminate"
		class="copo-datacenter-grid-icon-16" (click)="select($event)"></mat-icon>
</div>

<div *ngIf="params" class="ag-header-cell-label" [ngClass]="{'numeric-column-alignment':  headerAlignement() === true,
'other-column-alignment': headerAlignement() === false}">
	<button type="button" [ngClass]="{'numeric-column-text-alignment':  headerAlignement() === true}" class="ag-header-cell-text" (click)="onSortRequested($event)"
		>{{params.displayName}}</button>
	<button type="button" [title]="'datacenter.filters' | translate" [hidden]="params && !params.enableMenu" #menuButton (click)="onMenuClicked()">
		<span class="ag-header-icon ag-header-cell-menu-button e-menu ag-header-menu-always-show"
			aria-hidden="true">
			<mat-icon [ngClass]="{'active': params.column.isFilterActive()}" class="copo-datacenter-grid-icon-16"
				svgIcon="filters"></mat-icon>
		</span>
	</button>
	<button type="button" [title]="'datacenter.sorting' | translate" [hidden]="!params.enableSorting" (click)="onSortRequested($event)">
		<span class="ag-header-icon ag-header-cell-menu-button e-menu ag-header-menu-always-show"
			aria-hidden="true">
			<ng-container *ngIf="!sortingAscending && !sortingDescending">
				<mat-icon class="copo-datacenter-grid-icon-16" svgIcon="sorting_icon"></mat-icon>
			</ng-container>
			<ng-container *ngIf="sortingAscending">
				<mat-icon class="copo-datacenter-grid-icon-16 sorting-up-icon" svgIcon="sorting_up"></mat-icon>
			</ng-container>

			<ng-container *ngIf="sortingDescending">
				<mat-icon class="copo-datacenter-grid-icon-16 sorting-down-icon" svgIcon="sorting_down"></mat-icon>
			</ng-container>
		</span>
	</button>
</div>